import { useEffect, useState } from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import AnnouncementBar from "@/components/layout/AnnouncementBar";
import { Phone, MessageCircle } from "lucide-react";
import banner1 from "@/assets/GAY-PARTY-BANNERS.png";
import banner2 from "@/assets/GAY-PARTY-BANNERS2.png";

function PartyBanner() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev === 0 ? 1 : 0));
    }, 500);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pb-12 w-full">
      <a 
        href="https://wa.me/919560656913?text=Hi%20Hammam%20Mens%20Spa,%20I%20want%20to%20join%20the%20upcoming%20gay%20party%20this%20weekend." 
        target="_blank" 
        rel="noopener noreferrer" 
        className="block w-full overflow-hidden rounded-xl border border-hgold/20 hover:border-hgold/40 transition-colors bg-black/40"
      >
        <img 
          src={index === 0 ? banner1 : banner2} 
          alt="Wildest Gay Parties" 
          className="w-full h-auto object-cover" 
        />
      </a>
    </div>
  );
}

export default function PublicLayout() {
  const location = useLocation();
  const showBanner = ["/services", "/membership", "/doorstep", "/branches", "/about"].includes(location.pathname);

  return (
    <div className="min-h-screen flex flex-col bg-hblack">
      <AnnouncementBar />
      <Header />
      <main className="flex-1 pt-[104px]">
        <Outlet />
      </main>
      {showBanner && <PartyBanner />}
      <Footer />

      {/* Global Floating Action Buttons */}
      <div className="fixed bottom-6 right-6 z-[9999] flex flex-col gap-4">
        {/* Call Button */}
        <a
          href="tel:+919560656913"
          className="relative w-14 h-14 bg-[#B38728] hover:bg-[#BF953F] text-black rounded-full flex items-center justify-center shadow-lg transition-transform hover:scale-110 group animate-glow-gold"
          title="Call Now"
        >
          <Phone size={24} className="stroke-[2.5]" />
          <span className="absolute right-16 bg-[#B38728] text-black text-xs font-bold px-3 py-1 rounded shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap">
            Call Now
          </span>
        </a>

        {/* WhatsApp Button */}
        <a
          href="https://wa.me/919560656913?text=Hi%20Hammam%20Mens%20Spa,%20I'd%20like%20to%20book%20a%20session."
          target="_blank"
          rel="noopener noreferrer"
          className="relative w-14 h-14 bg-[#25D366] hover:bg-[#20ba5a] text-black rounded-full flex items-center justify-center shadow-lg transition-transform hover:scale-110 group animate-glow-green"
          title="WhatsApp Us"
        >
          <MessageCircle size={24} className="stroke-[2.5]" />
          <span className="absolute right-16 bg-[#25D366] text-black text-xs font-bold px-3 py-1 rounded shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap">
            WhatsApp Us
          </span>
        </a>
      </div>

      <style>{`
        @keyframes glowGold {
          0% {
            box-shadow: 0 0 0 0 rgba(179, 135, 40, 0.7);
          }
          70% {
            box-shadow: 0 0 0 15px rgba(179, 135, 40, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(179, 135, 40, 0);
          }
        }
        @keyframes glowGreen {
          0% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
          }
          70% {
            box-shadow: 0 0 0 15px rgba(37, 211, 102, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
          }
        }
        .animate-glow-gold {
          animation: glowGold 2s infinite;
        }
        .animate-glow-green {
          animation: glowGreen 2s infinite;
        }
      `}</style>
    </div>
  );
}
